
<template>
  <div class="welcome-bg">
    <!-- Burbujas animadas de fondo -->
    <div class="bubbles-container">
      <div class="bubble bubble-1"></div>
      <div class="bubble bubble-2"></div>
      <div class="bubble bubble-3"></div>
      <div class="bubble bubble-4"></div>
      <div class="bubble bubble-5"></div>
      <div class="bubble bubble-6"></div>
    </div>

    <!-- Emojis que aparecen y desaparecen -->
    <div class="floating-elements">
      <span class="floating-emoji emoji-1">📚</span>
      <span class="floating-emoji emoji-2">✏️</span>
      <span class="floating-emoji emoji-3">🌟</span>
      <span class="floating-emoji emoji-4">🎨</span>
      <span class="floating-emoji emoji-5">💡</span>
      <span class="floating-emoji emoji-6">🎯</span>
    </div>

    <v-container class="fill-height d-flex flex-column justify-center align-center">
      <v-card class="pa-8 welcome-card slide-in-up" max-width="650" elevation="0">
        <!-- Logos con efecto de rebote -->
        <div class="d-flex justify-center align-center mb-5">
          <img src="/images/logo_afinni.png" alt="Logo Afinni" class="welcome-logo mr-4 bounce-in" />
          <img src="/images/logo_colegio.jpg" alt="Logo Colegio" class="welcome-logo bounce-in delay-1" />
        </div>

        <!-- Título con emoji animado y nombre personalizado -->
        <v-card-title class="headline font-weight-bold mb-3 welcome-title justify-center">
          <span class="title-text zoom-in">
            <span class="wave-emoji">👋</span>
            {{ $t('welcome.greeting', { name: studentName }) }}
            <span class="sparkle-emoji">✨</span>
          </span>
        </v-card-title>

        <!-- Icono central con rotación suave -->
        <div class="d-flex justify-center mb-4">
          <div class="icon-container wiggle">
            <span class="central-emoji">🎓</span>
          </div>
        </div>

        <!-- Texto de bienvenida -->
        <v-card-text class="welcome-text fade-in delay-2">
          <p class="intro-text">
            <span class="emoji-inline">📝</span>
            {{ $t('welcome.intro') }}
          </p>
          <p class="objective-text mt-4">
            <span class="emoji-inline">💬</span>
            {{ $t('welcome.objective') }}
          </p>
        </v-card-text>

        <!-- Mensaje motivacional -->
        <div class="motivation-box fade-in delay-3">
          <span class="motivation-emoji">⭐</span>
          <span class="motivation-text">{{ $t('welcome.motivation') }}</span>
          <span class="motivation-emoji">⭐</span>
        </div>

        <!-- Botón de comenzar con efecto de pulso -->
        <v-card-actions class="justify-center mt-6">
          <v-btn
            class="welcome-btn pulse-btn"
            color="primary"
            x-large
            rounded
            @click="goToMain"
          >
            <span class="btn-emoji mr-2">🚀</span>
            {{ $t('welcome.start') }}
            <v-icon right class="btn-arrow">mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { useMainStore } from '@/store/main';
import { mapStores } from 'pinia';

export default {
  name: 'WelcomePage',
  computed: {
    ...mapStores(useMainStore),
    studentName() {
      return this.mainStore.logged_user.name || '';
    }
  },
  methods: {
    goToMain() {
      this.$router.replace({ name: 'ActiveSource' });
    }
  }
}
</script>

<style scoped>
/* Fondo suave - transición natural al blanco */
.welcome-bg {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f4ff 0%, #ffffff 50%, #f8fafc 100%);
  position: relative;
  overflow: hidden;
}

/* Burbujas animadas de fondo */
.bubbles-container {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.bubble {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  animation: rise 8s ease-in infinite;
}

.bubble-1 {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #74b9ff, #a29bfe);
  left: 10%;
  animation-delay: 0s;
}

.bubble-2 {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #fd79a8, #fdcb6e);
  left: 25%;
  animation-delay: 2s;
}

.bubble-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #55efc4, #81ecec);
  right: 15%;
  animation-delay: 1s;
}

.bubble-4 {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #ffeaa7, #fab1a0);
  right: 30%;
  animation-delay: 3s;
}

.bubble-5 {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #a29bfe, #74b9ff);
  left: 50%;
  animation-delay: 1.5s;
}

.bubble-6 {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #55efc4, #00b894);
  right: 5%;
  animation-delay: 4s;
}

@keyframes rise {
  0% {
    bottom: -100px;
    transform: translateX(0) scale(0.8);
    opacity: 0;
  }
  10% {
    opacity: 0.15;
  }
  50% {
    transform: translateX(30px) scale(1);
  }
  90% {
    opacity: 0.15;
  }
  100% {
    bottom: 110%;
    transform: translateX(-20px) scale(0.6);
    opacity: 0;
  }
}

/* Emojis flotantes */
.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.floating-emoji {
  position: absolute;
  font-size: 2rem;
  opacity: 0;
  animation: fadeFloat 4s ease-in-out infinite;
}

.emoji-1 { top: 15%; left: 8%; animation-delay: 0s; }
.emoji-2 { top: 25%; right: 10%; animation-delay: 0.8s; }
.emoji-3 { top: 55%; left: 5%; animation-delay: 1.6s; }
.emoji-4 { top: 65%; right: 8%; animation-delay: 2.4s; }
.emoji-5 { top: 35%; left: 4%; animation-delay: 3.2s; }
.emoji-6 { top: 75%; right: 12%; animation-delay: 4s; }

@keyframes fadeFloat {
  0%, 100% {
    opacity: 0;
    transform: translateY(0) scale(0.8);
  }
  20%, 80% {
    opacity: 0.7;
    transform: translateY(-10px) scale(1);
  }
  50% {
    opacity: 1;
    transform: translateY(-20px) scale(1.1);
  }
}

/* Tarjeta principal */
.welcome-card {
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.08),
    0 8px 25px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

/* Logos */
.welcome-logo {
  height: 65px;
  width: auto;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background: white;
  padding: 8px;
  transition: transform 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.welcome-logo:hover {
  transform: scale(1.08) rotate(2deg);
}

/* Título */
.welcome-title {
  text-align: center;
}

.title-text {
  font-size: 2.5rem;
  color: #2d3748;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
}

.wave-emoji {
  display: inline-block;
  animation: wave 1.8s ease-in-out infinite;
  transform-origin: 70% 70%;
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  10% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  30% { transform: rotate(14deg); }
  40% { transform: rotate(-4deg); }
  50%, 100% { transform: rotate(0deg); }
}

.sparkle-emoji {
  animation: twinkle 1.5s ease-in-out infinite;
}

@keyframes twinkle {
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
  50% { transform: scale(1.3) rotate(15deg); opacity: 0.7; }
}

/* Icono central */
.icon-container {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(9, 132, 227, 0.3);
}

.central-emoji {
  font-size: 3rem;
}

.wiggle {
  animation: wiggle 2.5s ease-in-out infinite;
}

@keyframes wiggle {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-8deg); }
  75% { transform: rotate(8deg); }
}

/* Textos */
.welcome-text {
  font-size: 1.15em;
  color: #4a5568;
  text-align: center;
  font-family: 'Quicksand', 'Roboto', Arial, sans-serif;
  line-height: 1.7;
}

.intro-text, .objective-text {
  display: block;
}

.emoji-inline {
  font-size: 1.3em;
  margin-right: 6px;
  vertical-align: middle;
}

/* Caja de motivación */
.motivation-box {
  background: linear-gradient(135deg, #fff9e6 0%, #ffeeba 100%);
  border-radius: 14px;
  padding: 14px 22px;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.motivation-emoji {
  font-size: 1.4rem;
  animation: starSpin 3s linear infinite;
}

@keyframes starSpin {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.15); }
  100% { transform: rotate(360deg) scale(1); }
}

.motivation-text {
  font-size: 1.05em;
  font-weight: 600;
  color: #856404;
  font-family: 'Quicksand', sans-serif;
}

/* Botón de comenzar */
.welcome-btn {
  font-size: 1.2em !important;
  font-weight: 700 !important;
  padding: 14px 36px !important;
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%) !important;
  box-shadow: 0 8px 25px rgba(9, 132, 227, 0.35) !important;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}

.welcome-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(9, 132, 227, 0.45) !important;
}

.pulse-btn {
  animation: btnPulse 2s ease-in-out infinite;
}

@keyframes btnPulse {
  0%, 100% {
    box-shadow: 0 8px 25px rgba(9, 132, 227, 0.35);
  }
  50% {
    box-shadow: 0 8px 35px rgba(9, 132, 227, 0.55), 0 0 0 8px rgba(9, 132, 227, 0.1);
  }
}

.btn-emoji {
  font-size: 1.3em;
}

.btn-arrow {
  transition: transform 0.3s ease;
}

.welcome-btn:hover .btn-arrow {
  transform: translateX(5px);
}

/* Animaciones de entrada */
.slide-in-up {
  animation: slideInUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bounce-in {
  animation: bounceIn 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
  opacity: 0;
}

.delay-1 { animation-delay: 0.15s; }
.delay-2 { animation-delay: 0.3s; }
.delay-3 { animation-delay: 0.45s; }

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.08);
  }
  70% {
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.zoom-in {
  animation: zoomIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: 0.2s;
  opacity: 0;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Responsive */
@media (max-width: 600px) {
  .title-text {
    font-size: 1.8rem;
  }

  .floating-emoji {
    font-size: 1.5rem;
  }

  .bubble {
    opacity: 0.1;
  }

  .welcome-logo {
    height: 50px;
  }

  .icon-container {
    width: 70px;
    height: 70px;
  }

  .central-emoji {
    font-size: 2.2rem;
  }

  .motivation-box {
    flex-direction: column;
    gap: 6px;
  }
}
</style>
